import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { routeNames } from 'src/app/app-routing-names';
import { QuoteSteps } from 'src/app/models/enums/quote-steps';
import { HouseholdQuoteStateService } from '../services/household-quote-state-service/household-quote-state.service';
import { StepService } from '../services/step-service/step.service';
@Injectable({
    providedIn: 'root'
})
export class QuoteStepGuard {
    constructor(public router: Router,
        private householdQuoteStateService: HouseholdQuoteStateService,
        private stepService: StepService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let requiredStep = route.data.step as number;
        let redirect = route.data.redirect as string;

        return this.isAllowedNavigate(requiredStep, redirect);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    canLoad(route: Route): boolean {
        let requiredStep = route.data.step as number;
        let redirect = route.data.redirect as string;

        return this.isAllowedNavigate(requiredStep, redirect);
    }

    isAllowedNavigate(requiredStep: number, redirect: string = routeNames.OWN_RENT_PROPERTY): boolean {
        let currentStep = this.householdQuoteStateService.getCurrentStep();

        if (currentStep == QuoteSteps.result && currentStep > requiredStep) {
            this.router.navigateByUrl(redirect)

            return false;
        }

        if (!currentStep || (currentStep < requiredStep && this.stepService.quoteFormStep$.value < requiredStep)) {
            this.router.navigateByUrl(redirect);

            return false;
        }

        return true;
    }
}
